<template>
  <b-row>
    <b-col cols="12" class="container min-vh-100">
      <DepartmentForm
        :departmentData="departmentData"
        @handleSubmit="onSubmitBtnClicked"
        @handleCancel="onCancelBtnClicked"
        @handleSetAddress="setAddress"
      ></DepartmentForm>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BFormInput,
  BFormGroup,
  BFormRadioGroup,
  BFormDatepicker,
  BFormTimepicker,
  BFormFile,
} from "bootstrap-vue";

import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";

import * as departmentStore from "@/store/api/department/index.js";
import * as storeFileUpload from "@/store/api/fileUpload/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import * as lang from "vuejs-datepicker/src/locale";

import DepartmentForm from "./components/DepartmentForm.vue";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
    BFormDatepicker,
    BFormTimepicker,
    BFormFile,
    ValidationObserver,
    ValidationProvider,
    extend,
    DepartmentForm,
  },
  data() {
    return {
      departmentData: {
        isActive: true,
      },
      languages: lang.th,
    };
  },
  created() {
    const _this = this;
    if (this.$route.query.id == null) {
      const id = null;
      this.getdepartmentById(id);
    } else {
      const id = this.$route.query.id;
      this.getdepartmentById(id);
    }
  },
  methods: {
    getdepartmentById(id) {
      const _this = this;

      departmentStore
        .getById(id)
        .then((response) => {
          console.log("response", response);
          _this.departmentData = response.data.data;          
        })
        .catch((error) => {
          console.log("error", error);
        });

      console.log("departmentData", _this.departmentData);
    },
    onSubmitBtnClicked() {
      const _this = this;

      _this.departmentData.updateBy = userData.userId();     
      _this.departmentData.deptType = 1; 

      departmentStore
        .updateItem(_this.departmentData)
        .then((response) => {
          if (response.data.success === true) {
            _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
              title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
              variant: "success",
              solid: false,
            });

            window.open(
              _this.$router.resolve({
                name: "ExternalDepartment",
              }).href,
              "_self"
            );
          } else {
            _this.$bvToast.toast("เกิดข้อผิดพลาด", {
              title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
              variant: "danger",
              solid: false,
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
          _this.$bvToast.toast("เกิดข้อผิดพลาด", {
            title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
            variant: "danger",
            solid: false,
          });
        });
    },
    onCancelBtnClicked() {
      window.open(
        this.$router.resolve({ name: "InternalDepartment" }).href,
        "_self"
      );
    },
    setAddress(address) {
      this.departmentData.addressModel.tumbonCode = address.subDistrictCode
      this.departmentData.addressModel.tumbon = address.subDistrictName
      this.departmentData.addressModel.ampherCode = address.districtCode
      this.departmentData.addressModel.ampher = address.districtName
      this.departmentData.addressModel.provinceCode = address.provinceCode
      this.departmentData.addressModel.province = address.provinceName
      this.departmentData.addressModel.zipcode = address.zipcode
    },
  },
};
</script>

<style lang="scss"></style>
